// removed by extract-text-webpack-plugin
module.exports = {"feedContainer":"_2u7od","waypointContainer":"_2u3ok"};


/*****************
 ** WEBPACK FOOTER
 ** /src/shared/styles/table/feedtable.scss
 ** module id = 1129
 ** module chunks = 0
 **/